export default "__VITE_ASSET__CHRy0YRN__"